/**
 * Card ActionTypes
 */
export enum ActionTypes {
  UPDATE_CARD_INPUT = "UPDATE_CARD_INPUT",
  UPDATE_BRANDS_LOGOS_LIST = "UPDATE_BRANDS_LOGOS_LIST",
  UPDATE_CARD_BRAND = "UPDATE_CARD_BRAND",
  SET_CARD_INPUT_DIRTY = "SET_CARD_INPUT_DIRTY",
  SWITCH_CARD_VALIDITY = "SWITCH_CARD_VALIDITY",
  SWITCH_IS_DEFERRED = "SWITCH_IS_DEFERRED",
  SET_CARD_TOKEN = "SET_CARD_TOKEN",
  SET_DEFERRED_OPTIONS = "SET_DEFERRED_OPTIONS",
  RESET_DEFERRED_OPTIONS = "RESET_DEFERRED_OPTIONS",
  UPDATE_DEFERRED_TYPE_SELECT = "UPDATE_DEFERRED_TYPE_SELECT",
  UPDATE_DEFERRED_SELECT_VALUE = "UPDATE_DEFERRED_SELECT_VALUE",
  SWITCH_DEFERRED_OPTIONS_VALIDITY = "SWITCH_DEFERRED_OPTIONS_VALIDITY",
  ENABLE_OTP_WAIT_VIEW = "ENABLE_OTP_WAIT_VIEW",
  UPDATE_OTP_STATE = "UPDATE_OTP_STATE",
  UPDATE_OTP_FAIL_MESSAGE = "UPDATE_OTP_FAIL_MESSAGE",
  UPDATE_SECURE_SERVICE_ID = "UPDATE_SECURE_SERVICE_ID",
  UPDATE_SECURE_SERVICE_NAME = "UPDATE_SECURE_SERVICE_NAME",
  UPDATE_OTP_VALUE = "UPDATE_OTP_VALUE",
  UPDATE_EMAIL_VALIDITY = "UPDATE_EMAIL_VALIDITY",
  DISABLE_OTP_WAIT_VIEW = "DISABLE_OTP_WAIT_VIEW",
  ENABLE_OTP_ERROR = "ENABLE_OTP_ERROR",
  DISABLE_OTP_ERROR = "DISABLE_OTP_ERROR",
  UPDATE_STATE = "UPDATE_STATE",
  DELETE_OTP_FAIL_MESSAGE = "DELETE_OTP_FAIL_MESSAGE",
  UPDATE_NESTED_MESSAGE = "UPDATE_NESTED_MESSAGE",
  UPDATE_NESTED_ERROR_CODE = "UPDATE_NESTED_ERROR_CODE",
  RESET_CARD_STATE = "RESET_CARD_STATE",
  ENABLE_VOUCHER_VIEW = "ENABLE_VOUCHER_VIEW",
  DISABLE_VOUCHER_VIEW = "DISABLE_VOUCHER_VIEW",
  UPDATE_AMOUNT_PER_MONTH = "UPDATE_AMOUNT_PER_MONTH",
  ENABLE_TOKEN_WITHOUT_CVV = "ENABLE_TOKEN_WITHOUT_CVV",
  SET_COMMISSION_CONFIG = "SET_COMMISSION_CONFIG",
  SET_COMMISSION_FLAG = "SET_COMMISSION_FLAG",
  SET_SHOW_COMMISSION_DETAILS = "SET_SHOW_COMMISSION_DETAILS",
  EXCEEDED_RETRIES = "EXCEEDED_RETRIES",
}



// WEBPACK FOOTER //
// ./src/containers/Card/store/ActionTypes.ts